import { getContactPreference } from './../../Api/quotationApi';
import cloneDeep from 'lodash/cloneDeep'
import { addAddress, signupUser } from 'Api/userApi'
import { addBuilding } from 'Api/companyApi'
import { apiErrorList } from 'Services/restAdviser'
import { formatCreateAddress } from 'Formatters/addressFormatter'
import { formatQuotation, formatDescriptionAI } from 'Formatters/quotationFormatter'
import { formatSignupUser } from 'Formatters/signupFormatter'
import { getCategoryList, getCategorySlugInfo, getServiceSlugInfo } from 'Api/categoryApi'
import { getQuestions, sendQuotation, getCompanyInfo, getAddressList, getQuotationPhone, sendQuotationLead, getSponsorship, getCrossOptions, sendQuotationLog, getAssistantDescription } from 'Api/quotationApi'
import { parseAddressList, parseQuotationService } from 'Parsers/categoryQuotationParser'
import { parseInfoQuotation } from 'Parsers/categoryInfoParser'
import pascalToCamelCase from 'Services/pascalToCamelCase'
import quotationType from 'Enums/quotationType'
import quotationOrigin from 'Enums/quotationOrigin'
import quotationStep from 'Enums/quotationStep'
import CategoryQuotationState from 'Types/_Store/CategoryQuotation'
import { getPhone, addPhone, getPhoneList, checkPhone, removePhone, refreshPhoneToken } from 'Api/userPhoneApi'
import userPhoneTypes from 'Enums/userPhoneTypes'
import { ApiUserPhoneCheck, ApiUserPhoneResult, IQuotationLog } from 'Types'
import { v4 as uuidv4 } from 'uuid'

const state: CategoryQuotationState = {
  requesting: {
    company: false,
    question: false,
    quotation: false,
    quotationLead: false,
    addressList: false,
    newAddress: false,
    newUser: false,
    serviceType: false,
    meta: false,
    phoneValidation: false,
    phoneCheck: false,
    signupLogin: false,
    sponsor: false,
    cross: false,
    quotationLog: false,
    contactPreference: false
  },

  status: {
    isAuthenticated: false,
    isFetching: false,
    isSent: false,
    isDirty: null,
    isNewUser: null,
  },

  currentStep: {
    id: 0,
    name: 'serviceType',
    innerStep: 0,
  },

  stepList: [
    {
      id: quotationStep.serviceType,
      name: 'serviceType',
      text: 'Especialidade',
      lastInnerStep: 0
    },
    {
      id: quotationStep.details,
      name: 'details',
      text: 'Detalhes',
      lastInnerStep: 0
    },
    {
      id: quotationStep.info,
      name: 'info',
      text: 'Dados',
      lastInnerStep: 0
    },
    {
      id: quotationStep.deadline,
      name: 'deadline',
      text: 'Prazo',
      lastInnerStep: 0
    }
  ],

  verifiedAddress: false,
  verifiedPhone: false,
  invalidStep: null,
  currentQuotationLogId: null,
  meta: {
    id: null,
    sessionIdentifier: '',
    group: '',
    title: '',
    description: '',
    icon: null,

    breadcrumb: {
      category: '',
      serviceType: '',
    },

    slug: {
      serviceType: '',
      category: '',
      region: '',
    },

    images: {
      mobile: '',
      desktop: '',
    },
  },

  info: {
    replacement: false,
    origin: null,
    type: null,
    form: null,
    serviceType: null,
    deadline: null,
    address: null,
    email: '',
    details: '',
    phoneDDD: '',
    phoneNumber: '',
    typeReceivement: {
      typeReceivementValue: null
    },
    slug: {
      region: '',
      state: '',
      city: ''
    },
    receiveSponsorship: false,
    crossQuotServiceTypeIds: [],
    contactPreference: 0,
  },

  newAddress: {
    description: null,
    zipcode: null,
    cityId: null,
    stateId: null,
    neighborhood: null,
    street: null,
    streetNumber: null,
    streetDetails: null,
    isMain: false,
  },

  newUser: {
    name: '',
    occupation: null,
    otherOccupation: '',
    email: '',
    password: '',
    phone: {
      ddd: '',
      number: '',
    },
    address: {
      description: '',
      type: '',
      zipcode: '',
      cityId: '',
      stateId: '',
      neighborhood: '',
      street: '',
      streetNumber: '',
      streetDetails: '',
    }
  },

  description: '',

  sponsor: null,

  crossOptions: [],

  addressList: [],
  answerList: [],
  companyList: [],
  fileList: [],
  notificationList: [],
  questionList: [],
  serviceTypeList: [],
  errorList: [],
  errorMessage: '',
  categoryId: null
}

const getters = {
  isQuotationValid: (state) => {
    const { origin, type, form, serviceType, deadline, address } = state.info

    const stepIsValid = step => step !== null

    const requiredSteps = state.status.isNewUser
      ? [origin, type, form, serviceType, deadline]
      : [origin, type, form, serviceType, deadline, address]

    return requiredSteps.every(stepIsValid)
  },

  currentFormItem: (state) => {
    const questionAnswer = answer => question && answer.id === question.id

    const questionIndex = state.currentStep.innerStep
    const question = state.questionList[questionIndex]
    const answer = state.answerList.find(questionAnswer)

    const questionData = {
      question: question || null,
      answer: answer || null,
    }

    return questionData
  },

  isFormStepValid: (_, getters) => {
    const { question, answer } = getters.currentFormItem

    const isQuestionOptional = question && question.required === false
    const isQuestionAnswered = answer !== null

    return isQuestionOptional || isQuestionAnswered
  },

  stepDetails: (state) => increment => {
    const { stepList, currentStep } = state

    const ongoingStep = stepList.find(step => step.id === currentStep.id)
    const followingStep = stepList[stepList.indexOf(ongoingStep) + increment] || null
    const nextInnerStep = currentStep.innerStep + increment

    const stepStatus = {
      ongoingStep,
      followingStep,
      nextInnerStep,
    }

    return stepStatus
  },

  isQuotationLastInnerStep: (state, getters) => {
    const { ongoingStep, followingStep } = getters.stepDetails(1)
    const { status, currentStep } = state

    const isLastInnerStep = ongoingStep.lastInnerStep == currentStep.innerStep
    const isLastStep = followingStep === null
    const isKnownUser = status.isNewUser !== null

    return isKnownUser && isLastStep && isLastInnerStep
  },

  isQuotationReady: (state, getters) => {
    const { isQuotationValid, isQuotationLastInnerStep } = getters
    const { invalidStep } = state

    const isStepValid = invalidStep === null

    return isStepValid && isQuotationValid && isQuotationLastInnerStep
  },

  quotationServiceType: (state) => {
    const serviceList = state.serviceTypeList.find(item => item.id === state.info.serviceType)

    return serviceList || null
  }
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_quotation_validation(state, { invalidStep, errorList, isDirty, errorMessage }) {
    state.invalidStep = invalidStep
    state.errorList = errorList
    state.errorMessage = errorMessage
    state.status.isDirty = isDirty
  },

  set_quotation_step_list(state, stepList) {
    state.stepList = stepList
  },

  set_quotation_step(state, newStep) {
    state.currentStep = Object.assign({}, state.currentStep, newStep)
  },

  set_quotation_info(state, info) {
    state.info = Object.assign(state.info, info)
  },

  set_quotation_meta(state, meta) {
    state.meta = Object.assign(state.meta, meta)
  },

  set_quotation_status(state, status) {
    state.status = Object.assign(state.status, status)
  },

  set_quotation_new_address(state, newAddress) {
    state.newAddress = Object.assign(state.newAddress, newAddress)
  },

  set_quotation_new_user(state, newUser) {
    Object.assign(state.newUser, newUser)
  },

  set_quotation_new_user_phone(state, phone) {
    Object.assign(state.newUser.phone, phone)
  },

  set_quotation_new_user_address(state, address) {
    Object.assign(state.newUser.address, address)
  },

  set_quotation_new_user_email(state, email) {
    state.newUser.email = email
  },

  set_quotation_answer(state, answerList) {
    state.answerList = answerList
  },

  set_quotation_question(state, questionList) {
    state.questionList = questionList
  },

  set_quotation_company(state, companyList) {
    state.companyList = companyList
  },

  set_quotation_notification(state, notificationList) {
    state.notificationList = notificationList
  },

  set_quotation_file(state, fileList) {
    state.fileList = fileList
  },

  set_quotation_address_list(state, addressList) {
    state.addressList = addressList
  },

  set_quotation_servicetype_list(state, serviceTypeList) {
    state.serviceTypeList = serviceTypeList
  },

  set_verified_address(state, verifiedAddress) {
    state.verifiedAddress = verifiedAddress
  },

  set_verified_phone(state, verifiedPhone) {
    state.verifiedPhone = verifiedPhone
  },

  set_category_id(state, id) {
    state.categoryId = id
  },

  set_sponsor(state, sponsor) {
    state.sponsor = sponsor
  },

  set_cross_options(state, options) {
    state.crossOptions = options
  },

  set_current_quotation_log_id(state, id ) {
    state.currentQuotationLogId = id
  },

  set_contact_preference(state, preference ) {
    state.info.contactPreference = preference
  }
}

const actions = {
  // #region Setup
  initQuotationState({ dispatch }, options) {
    const { isAuthenticated, companyList, origin, type } = options

    dispatch('setSessionIdentifier')

    if (companyList.length) {
      dispatch('enableSpecialQuotation', { companyList, origin, type })
    } else {
      dispatch('enableSmartQuotation', { origin })
    }

    if (isAuthenticated) {
      dispatch('enableAuthQuotation')
      dispatch('getQuotationPhone')
    }
  },

  setSessionIdentifier({ commit }) {
      let sessionIdentifier = sessionStorage.getItem('sessionIdentifier')

      if(!sessionIdentifier)
        sessionIdentifier = uuidv4()

      commit('set_quotation_meta', { sessionIdentifier })
      sessionStorage.setItem('sessionIdentifier', sessionIdentifier)
  },

  async getQuotationPhone({ commit }) {
    commit('request_start', 'phone')

    try {
      const { data } = await getQuotationPhone()
      const { ddd: phoneDDD, number: phoneNumber } = data

      if (phoneDDD && phoneNumber) 
        commit('set_quotation_info', { phoneDDD, phoneNumber })

      commit('request_success', 'phone')

      return data    
    } catch (err) {
      commit('request_failure', 'phone')

      throw err
    }
  },

  enableAuthQuotation({ commit, state, dispatch }) {
    dispatch('getPhone')

    const isNewUser = false
    commit('set_quotation_status', { isNewUser })

    const { stepList, currentStep } = state
    const newStepList = cloneDeep(stepList)
    const info = stepList.find(item => item.name === 'info')
    const details = stepList.find(item => item.name === 'details')

    newStepList.sort((b, a) =>
      a.id === details.id && b.id === info.id
        ? -1 // Move one step back
        : 0  // Keep step position
    )

    commit('set_quotation_step_list', newStepList)

    if (currentStep.id === stepList[0].id) {
      const { id, name, lastInnerStep } = newStepList[0]

      commit('set_quotation_step', { id, name, innerStep: lastInnerStep })
    }

    commit('set_quotation_status', { isAuthenticated: true })
  },

  enableSpecialQuotation({ commit, dispatch, state }, { origin, type, companyList }) {
    const { stepList } = state
    const { special, smart } = quotationType
    const { coteiBem } = quotationOrigin

    commit('set_quotation_info', {
      replacement: true,
      origin: origin !== coteiBem
        ? origin
        : coteiBem,
      type: type !== smart
        ? type
        : special,
    })

    const newStepList = stepList.filter(item => item.name !== 'serviceType')
    commit('set_quotation_step_list', newStepList)

    const { id, name, lastInnerStep } = newStepList[0]
    commit('set_quotation_step', { id, name, innerStep: lastInnerStep })

    dispatch('getAsyncCompaniesInfo', companyList)
  },

  enableSmartQuotation({ commit }, { origin }) {
    const { smart } = quotationType
    const { coteiBem } = quotationOrigin

    commit('set_quotation_info', {
      type: smart,
      replacement: true,
      origin: origin !== coteiBem
        ? origin
        : coteiBem
    })
  },

  toggleReplacement({ state, commit }) {
    const { replacement } = state.info

    commit('set_quotation_info', { replacement: !replacement, })
  },
  // #endregion

  // #region Verification
  verifyAddress({ commit }) {
    commit('set_verified_address', true)
  },

  unverifyAddress({ commit }) {
    commit('set_verified_address', false)
  },

  verifyPhone({ commit }) {
    commit('set_verified_phone', true)
  },

  unverifyPhone({ commit }) {
    commit('set_verified_phone', false)
  },
  // #endregion

  // #region Companies
  async getAsyncCompaniesInfo({ commit }, idList) {
    commit('request_start', 'company')

    try {
      const { data } = await getCompanyInfo(idList)

      commit('request_success', 'company')
      commit('set_quotation_company', data)

      return data
    } catch (err) {
      const notifyList = apiErrorList(err)

      commit('request_failure', 'company')
      commit('set_quotation_notification', notifyList)

      throw err
    }
  },

  updateCompanies({ commit }, companies) {
    commit('set_quotation_company', companies)
  },

  removeCompany({ commit, state }, companyId: number) {
    const companyList = state.companyList.filter(company => company.id !== companyId)

    commit('set_quotation_company', companyList)

    return companyList
  },
  // #endregion

  // #region Form questions
  async getQuestions({ state, commit, dispatch }) {
    commit('request_start', 'question')

    try {
      const { data } = await getQuestions(state.info.serviceType, state.info.address)
      let { id, formItens } = data

      const quotationInfo = { form: id }

      if (!state.status.isAuthenticated) {
        formItens.splice(1, 0, {
          id: 9990,
          inputType: "EMAIL"
        })
      }

      const lastInnerStep = { name: 'details', lastInnerStep: formItens.length }

      commit('set_quotation_question', formItens)
      commit('set_quotation_info', quotationInfo)
      dispatch('updateLastInnerStep', lastInnerStep)

      commit('request_success', 'question')

      return data
    } catch (err) {
      const notifyList = apiErrorList(err)

      commit('request_failure', 'question')
      commit('set_quotation_notification', notifyList)

      throw err
    }
  },

  removeAnswer({ state, commit }, id) {
    let clonedAnswerList = JSON.parse(JSON.stringify(state.answerList))
    clonedAnswerList = clonedAnswerList.filter(answer => answer.id !== id)

    commit('set_quotation_answer', clonedAnswerList)
  },

  updateAnswer({ state, commit }, answer) {
    let clonedAnswerList = JSON.parse(JSON.stringify(state.answerList))

    if (clonedAnswerList.some(item => item.id === answer.id)) {
      clonedAnswerList = clonedAnswerList.map(item => item.id === answer.id ? answer : item)
    } else {
      clonedAnswerList.push(answer)
    }

    commit('set_quotation_answer', clonedAnswerList)
  },
  // #endregion

  // #region Steps & validations
  goToPreviousStep({ getters, commit }) {
    const { followingStep, nextInnerStep } = getters.stepDetails(-1)

    const hasMoreSteps = (followingStep !== null)
    const hasMoreInnerSteps = (nextInnerStep >= 0)
    const isFirstInnerStep = (nextInnerStep < 0)

    if (hasMoreSteps && isFirstInnerStep) {
      const { id, name, lastInnerStep } = followingStep

      commit('set_quotation_step', { id, name, innerStep: lastInnerStep })
    }
    else if (hasMoreInnerSteps) {
      commit('set_quotation_step', { innerStep: nextInnerStep })
    }
  },

  goToNextStep({ commit, dispatch, state, getters }) {
    const { ongoingStep, followingStep, nextInnerStep } = getters.stepDetails(1)
    const { status } = state

    const isStepInvalid = state.invalidStep !== null
    const isNextStep = nextInnerStep > ongoingStep.lastInnerStep

    const log = {
      email: state.newUser.email,
      id: state.currentStep.id,
      innerStep: state.currentStep.innerStep
    }

    if (isStepInvalid) {
      dispatch('updateValidation', { isDirty: true })
    } else {
      commit('set_quotation_status', { isDirty: false })


      if (getters.isQuotationReady) {
        dispatch('sendAuthQuotation')
      } else if (isNextStep) {
        const { id, name } = followingStep

        commit('set_quotation_step', { id, name, innerStep: 0 })
        dispatch('sendQuotationLog', log)

      } else {
        commit('set_quotation_step', { innerStep: nextInnerStep })
        dispatch('sendQuotationLog', log)

      }
    }
  },

  updateStepList({ commit }, stepList) {
    commit('set_quotation_step_list', stepList)
  },

  updateLastInnerStep({ state, commit }, stepType) {
    const stepList = state.stepList.map(step => {
      const newStep = { ...step }

      if (step.name === stepType.name) {
        newStep.lastInnerStep = stepType.lastInnerStep
      }

      return newStep
    })

    commit('set_quotation_step_list', stepList)
  },

  updateCurrentStep({ commit }, stepType) {
    commit('set_quotation_step', stepType)
  },

  updateValidation({ commit, state }, options) {
    const isDefined = (value) => typeof value !== 'undefined'

    const invalidStep = isDefined(options.invalidStep)
      ? options.invalidStep
      : { ...state.currentStep }

    const errorList = isDefined(options.errorList)
      ? options.errorList
      : state.errorList

    const isDirty = isDefined(options.isDirty)
      ? options.isDirty
      : state.status.isDirty

    const errorMessage = isDefined(options.errorMessage)
      ? options.errorMessage
      : state.errorMessage

    const validation = {
      invalidStep,
      errorList,
      isDirty,
      errorMessage,
    }

    commit('set_quotation_validation', validation)
  },
  // #endregion

  // #region Status & Notificaitons & Meta SEO Data
  async getServiceList({ commit }, id) {
    commit('request_start', 'serviceType')

    try {
      const { data } = await getCategoryList(id)
      const [category] = data

      commit('set_category_id', category.id)

      const serviceTypeList = category.serviceTypes.map(parseQuotationService)
      commit('set_quotation_servicetype_list', serviceTypeList)

      commit('request_success', 'serviceType')

      return data
    } catch (err) {
      const notifyList = apiErrorList(err)

      commit('set_quotation_notification', notifyList)
      commit('request_failure', 'serviceType')

      throw err
    }
  },

  async getQuotationMeta({ commit }, slug) {
    try {
      const { data } = slug.serviceType !== ''
        ? await getServiceSlugInfo(slug.serviceType)
        : await getCategorySlugInfo(slug.category)

      const info = parseInfoQuotation(data)
      commit('set_quotation_meta', info)

      return data
    } catch (err) {
      throw err
    }
  },

  updateCategoryMeta({ commit }, data) {
    const syncData = pascalToCamelCase(data)
    const info = parseInfoQuotation(syncData)

    commit('set_quotation_meta', info)
  },

  updateInfo({ commit }, info) {
    commit('set_quotation_info', info)
  },

  updateStatus({ commit }, status) {
    commit('set_quotation_status', status)
  },

  resetNotifications({ commit }) {
    commit('set_quotation_notification', [])
  },
  // #endregion

  // #region Files
  addFile({ state, commit }, file) {
    const newList = [].concat(state.fileList, file)

    commit('set_quotation_file', newList)
  },

  removeFile({ state, commit }, fileKey) {
    const newList = state.fileList.filter(file => file.key !== fileKey)

    commit('set_quotation_file', newList)
  },

  updateFile({ state, commit }, { key, data }) {
    const { fileList } = state

    const newList = fileList.filter(file => file.key !== key)
    const file = fileList.find(file => file.key === key)

    newList.push(Object.assign({}, file, data))

    commit('set_quotation_file', newList)
  },
  // #endregion

  // #region Addresses
  async getAddressList({ commit, dispatch }) {
    commit('request_start', 'addressList')

    try {
      const { data } = await getAddressList()
      const addressList = parseAddressList(data)

      commit('set_quotation_address_list', addressList)
      commit('request_success', 'addressList')


      return data
    } catch (err) {
      const notifyList = apiErrorList(err)

      commit('request_failure', 'addressList')
      commit('set_quotation_notification', notifyList)

      throw err
    }
  },

  async addNewAddress({ state, commit }, addressType) {
    commit('request_start', 'newAddress')

    try {
      let endpoint = {
        'user': addAddress,
        'company': addBuilding,
      }[addressType]

      const parsedAddress = formatCreateAddress(state.newAddress)
      const result = await endpoint(parsedAddress)
      commit('request_success', 'newAddress')

      return result
    } catch (err) {
      const notifyList = apiErrorList(err)

      commit('request_failure', 'newAddress')
      commit('set_quotation_notification', notifyList)

      throw err
    }
  },

  selectAddress({ commit }, address) {
    commit('set_quotation_info', { address })
  },

  updateNewAddress({ commit }, newAddress) {
    commit('set_quotation_new_address', newAddress)
  },

  resetNewAddress({ commit, state }) {
    const newAddress = { ...state.newAddress }

    Object.keys(newAddress).forEach(key => {
      if (key === 'isMain') {
        newAddress[key] = false
      } else {
        newAddress[key] = null
      }
    })

    commit('set_quotation_new_address', newAddress)
  },

  updateAddressList({ commit }, addressList) {
    commit('set_quotation_address_list', addressList)
  },

  async selectFirstAddress({ dispatch }) {
    try {
      const addressList = await dispatch('getAddressList')

      const firstAddress = addressList[0]
      dispatch('updateInfo', { address: firstAddress.id })

      return firstAddress
    } catch (err) {
      throw err
    }
  },
  // #endregion

  // #region newUser
  updateNewUser({ commit }, newUser) {
    commit('set_quotation_new_user', newUser)
  },

  updateNewUserPhone({ commit }, phone) {
    commit('set_quotation_new_user_phone', phone)
  },

  updateNewUserAddress({ commit }, address) {
    commit('set_quotation_new_user_address', address)
  },

  updateNewUserEmail({ commit }, email) {
    commit('set_quotation_new_user_email', email)
  },

  async signupNewUser({ commit, state }) {
    commit('request_start', 'newUser')

    try {
      const user = formatSignupUser(state.newUser)
      const result = await signupUser(user)

      const credentials = {
        email: user.email,
        password: user.password,
        isPersistent: true
      }

      commit('request_success', 'signupUser')

      return { result, credentials }
    } catch (err) {
      commit('request_failure', 'newUser')

      throw err
    }
  },

  async loginNewUser({ commit, dispatch }, authCredentials) {
    const root = true // Enable the dispatch of actions in the global namespace

    try {
      const credentials = await dispatch('account/updateCredentials', authCredentials, { root })

      const login = await dispatch('account/login', null, { root })

      commit('set_quotation_status', { isAuthenticated: true })

      return { credentials, login }
    } catch (err) {
      throw err
    }
  },
  // #endregion

  // #region Submit
  resetStep({ state, commit }, { stepName, stepPosition }) {
    const stepList = cloneDeep(state.stepList)
    const innerStep = stepList.find(step => step.name === stepName)

    innerStep.lastInnerStep = 0

    const quotationStep = {
      id: innerStep.id,
      name: stepName,
      innerStep: stepPosition
    }

    commit('set_quotation_step_list', stepList)
    commit('set_quotation_step', quotationStep)
  },

  async signupThenLoginUser({ commit, dispatch, state }) {
    commit('request_start', 'signupLogin')

    try {
      const { credentials } = await dispatch('signupNewUser')
      await dispatch('loginNewUser', credentials)
      await dispatch('selectFirstAddress')

      dispatch('resetStep', { stepName: 'info', stepPosition: 1 })
      dispatch('updateStatus', { isNewUser: false })

      commit('set_verified_address', true)
      commit('request_success', 'signupLogin')

      return state.newUser
    } catch (err) {
      const notifyList = apiErrorList(err)

      commit('request_failure', 'signupLogin')
      commit('set_quotation_notification', notifyList)

      throw err
    }
  },

  async sendDescriptionAI({ state }, description) {
    try {
      const assistantData = formatDescriptionAI(
        description,
        state.answerList,
        state.info.serviceType
      )
      const result = await getAssistantDescription(assistantData)
      console.log('result', result.data)
      return result.data
    }
    catch (err) {
      throw err
    }
  },
  async sendAuthQuotation({ commit, state, dispatch }) {
    commit('request_start', 'quotation')

    try {
      const quotationData = formatQuotation(
        state.info,
        state.answerList,
        state.fileList,
        state.companyList,
      )

      const result = await sendQuotation(quotationData)

      if (typeof window !== 'undefined') {
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({
          event: 'conversion_quotation',
          igoal_adv_sub: String(result.data)
        });
      }

      const log = {
        email: state.newUser.email,
        id: state.currentStep.id,
        innerStep: state.currentStep.innerStep,
        quotationId: result.data
      }

      dispatch('sendQuotationLog', log)

      commit('set_quotation_status', { isSent: true })
      commit('request_success', 'quotation')

      return result
    }
    catch (err) {
      const notifyList = apiErrorList(err)

      commit('set_quotation_notification', notifyList)
      commit('request_failure', 'quotation')

      throw err
    }
  },

  async postQuotationLead({ commit, state }) {
    commit('request_start', 'quotationLead')

    try {
      const quotationData = {
        email:  state.newUser.email,
        sessionIdentifier: state.meta.sessionIdentifier,
        serviceTypeSlug: state.meta.slug.serviceType,
        stateSlug: state.info.slug.state,
        citySlug: state.info.slug.city,
        quotationType: state.info.type,
        originQuotation: state.info.origin,
        companies: state.companyList
      }

      const result = await sendQuotationLead(quotationData)

      commit('request_success', 'quotationLead')

      return result
    }
    catch (err) {
      const notifyList = apiErrorList(err)

      commit('set_quotation_notification', notifyList)
      commit('request_failure', 'quotation')

      throw err
    }
  },

  async sendQuotationLog({ commit, state }, data) {
    commit('request_start', 'quotationLog')

    try {
      const quotationData = {
        quotationId: null,
        quotationLogId: state.currentQuotationLogId,
        ...data
      } as IQuotationLog

      const result = await sendQuotationLog(quotationData)

      commit('set_current_quotation_log_id', result.data)

      commit('request_success', 'quotationLog')

      return result
    }
    catch (err) {
      const notifyList = apiErrorList(err)

      commit('set_quotation_notification', notifyList)
      commit('request_failure', 'quotationLog')

      throw err
    }
  },
  // #endregion

  // #region Phone
  removeVerifiedPhone({ commit }) {
    commit('set_quotation_info', { phoneDDD: '', phoneNumber: '' })
    commit('set_verified_phone', false)
  },

  updateVerifiedPhone({ commit }, phone) {
    const { localCodeArea: phoneDDD, number: phoneNumber } = phone
    const verified = phone.status === userPhoneTypes.verified

    commit('set_quotation_info', { phoneDDD, phoneNumber })
    commit('set_verified_phone', verified)

    return { verified }
  },

  async getPhone({ dispatch }) {
    try {
      const { data } = await getPhoneList()
      const [phone] = data

      if (phone) {
        dispatch('updateVerifiedPhone', phone)
      }

      return data
    } catch (err) {
      throw err
    }
  },

  async requestPhoneVerification({ state, commit, dispatch }) {
    commit('request_start', 'phoneCheck')

    try {
      const { phoneDDD, phoneNumber } = state.info
      const { data } = await getPhoneList()

      const phone = data.find(item =>
        item.number === phoneNumber && item.localCodeArea === phoneDDD
      )

      if (phone) {
        await dispatch('deletePhone', phone)
      }

      const token = await dispatch('createPhoneForVerification')

      commit('request_success', 'phoneCheck')

      return token
    } catch (err) {
      const notifyList = apiErrorList(err)

      dispatch('goToPreviousStep')
      commit('set_quotation_notification', notifyList)

      commit('request_failure', 'phoneCheck')

      throw err
    }
  },

  async deletePhone({ commit }, phone: ApiUserPhoneResult) {
    const { data } = await removePhone(phone.id)

    return data
  },

  async createPhoneForVerification({ state, commit }) {
    const { phoneDDD, phoneNumber } = state.info
    const { typeReceivementValue } = state.info.typeReceivement
    const { data } = await addPhone(phoneDDD, phoneNumber, typeReceivementValue)

    return data.token
  },

  async validatePhone({ commit, dispatch }, payload: ApiUserPhoneCheck) {
    commit('request_start', 'phoneValidation')

    try {
      const { data } = await checkPhone(payload)
      dispatch('updateValidation', { errorList: [], invalidStep: null })
      dispatch('resetStep', { stepName: 'info', stepPosition: 2 })
      commit('set_verified_phone', true)
      //dispatch('goToNextStep')

      commit('request_success', 'phoneValidation')

      return data
    } catch (err) {
      const notifyList = apiErrorList(err)
      commit('set_quotation_notification', notifyList)

      commit('request_failure', 'phoneValidation')

      throw err
    }
  },

  async refreshPhoneToken({ state }) {
    const { phoneDDD, phoneNumber } = state.info
    const { typeReceivementValue } = state.info.typeReceivement
    try {
      const { data } = await refreshPhoneToken(phoneDDD, phoneNumber, typeReceivementValue)

      return data.token
    } catch (err) {
      throw err
    }
  },
  // #endregion

  // #region SessionStorage
  getRegionSlugFromSessionStorage({ commit }) {
    const region = sessionStorage.getItem('state/city')

    if(region !== null) {
      const state = region.split("/")[0] || ''
      const city = region.split("/")[1] || ''
      const slug = {
        region,
        state,
        city,
      }
      commit('set_quotation_info', { slug })
    }
  },
  // #endregion

  async getSponsor({ commit }) {
    const { serviceType } = state.info
    const { categoryId } = state

    commit('request_start', 'sponsor')
    try {
      const { data } = await getSponsorship(categoryId, serviceType)

      commit('set_sponsor', data)

      commit('request_success', 'sponsor')
      return data.token
    } catch (err) {
      commit('request_failure', 'sponsor')

      throw err
    }
  },
  toggleReceiveSponsorship({ state, commit }) {
    const { receiveSponsorship } = state.info

    commit('set_quotation_info', { receiveSponsorship: !receiveSponsorship, })
  },

  async getCrossOptions({ commit }) {
    const { serviceType } = state.info

    commit('request_start', 'cross')
    try {
      const { data } = await getCrossOptions(serviceType)

      commit('set_cross_options', data)

      commit('request_success', 'cross')
      return data
    } catch (err) {
      commit('request_failure', 'cross')

      throw err
    }
  },

  updateSelectedCrossOptions({commit}, options) {
    try {
      commit('set_quotation_info', { crossQuotServiceTypeIds: options, })

    } catch (error) {

      throw error
    }
  },

  async getContactPreference({ commit }) {
    commit('request_start', 'contactPreference')
    try {
      const { data } = await getContactPreference()

      if (data !== 0)
        commit('set_contact_preference', data)

      commit('request_success', 'contactPreference')
      return data
    } catch (err) {
      commit('request_failure', 'contactPreference')

      throw err
    }
  },

  async sendContactPreference({ commit }, option) {
    try {

      commit('set_contact_preference', option)

    } catch (err) {

      throw err
    }
  },
}

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions
}